// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cesium-baseLayerPicker-selected {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.cesium-baseLayerPicker-dropDown {
  display: block;
  position: absolute;
  box-sizing: content-box;
  top: auto;
  right: 0;
  width: 320px; /* Includes space needed for scrollbar */
  max-height: 500px;
  margin-top: 5px;
  background-color: rgba(38, 38, 38, 0.75);
  border: 1px solid #444;
  padding: 6px;
  overflow: auto;
  border-radius: 10px;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  transform: translate(0, -20%);
  visibility: hidden;
  opacity: 0;
  transition:
    visibility 0s 0.2s,
    opacity 0.2s ease-in,
    transform 0.2s ease-in;
}

.cesium-baseLayerPicker-dropDown-visible {
  transform: translate(0, 0);
  visibility: visible;
  opacity: 1;
  transition:
    opacity 0.2s ease-out,
    transform 0.2s ease-out;
}

.cesium-baseLayerPicker-sectionTitle {
  display: block;
  font-family: sans-serif;
  font-size: 16pt;
  text-align: left;
  color: #edffff;
  margin-bottom: 4px;
}

.cesium-baseLayerPicker-choices {
  margin-bottom: 5px;
}

.cesium-baseLayerPicker-categoryTitle {
  color: #edffff;
  font-size: 11pt;
}

.cesium-baseLayerPicker-choices {
  display: block;
  border: 1px solid #888;
  border-radius: 5px;
  padding: 5px 0;
}

.cesium-baseLayerPicker-item {
  display: inline-block;
  vertical-align: top;
  margin: 2px 5px;
  width: 64px;
  text-align: center;
  cursor: pointer;
}

.cesium-baseLayerPicker-itemLabel {
  display: block;
  font-family: sans-serif;
  font-size: 8pt;
  text-align: center;
  vertical-align: middle;
  color: #edffff;
  cursor: pointer;
  word-wrap: break-word;
}

.cesium-baseLayerPicker-item:hover .cesium-baseLayerPicker-itemLabel,
.cesium-baseLayerPicker-item:focus .cesium-baseLayerPicker-itemLabel {
  text-decoration: underline;
}

.cesium-baseLayerPicker-itemIcon {
  display: inline-block;
  position: relative;
  width: inherit;
  height: auto;
  background-size: 100% 100%;
  border: solid 1px #444;
  border-radius: 9px;
  color: #edffff;
  margin: 0;
  padding: 0;
  cursor: pointer;
  box-sizing: border-box;
}

.cesium-baseLayerPicker-item:hover .cesium-baseLayerPicker-itemIcon {
  border-color: #fff;
  box-shadow:
    0 0 8px #fff,
    0 0 8px #fff;
}

.cesium-baseLayerPicker-selectedItem .cesium-baseLayerPicker-itemLabel {
  color: rgb(189, 236, 248);
}

.cesium-baseLayerPicker-selectedItem .cesium-baseLayerPicker-itemIcon {
  border: double 4px rgb(189, 236, 248);
}
`, "",{"version":3,"sources":["webpack://./cesium/Source/Widgets/BaseLayerPicker/BaseLayerPicker.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,QAAQ;EACR,YAAY,EAAE,wCAAwC;EACtD,iBAAiB;EACjB,eAAe;EACf,wCAAwC;EACxC,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV;;;0BAGwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,UAAU;EACV;;2BAEyB;AAC3B;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,UAAU;EACV,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB;;gBAEc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[".cesium-baseLayerPicker-selected {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n.cesium-baseLayerPicker-dropDown {\n  display: block;\n  position: absolute;\n  box-sizing: content-box;\n  top: auto;\n  right: 0;\n  width: 320px; /* Includes space needed for scrollbar */\n  max-height: 500px;\n  margin-top: 5px;\n  background-color: rgba(38, 38, 38, 0.75);\n  border: 1px solid #444;\n  padding: 6px;\n  overflow: auto;\n  border-radius: 10px;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  transform: translate(0, -20%);\n  visibility: hidden;\n  opacity: 0;\n  transition:\n    visibility 0s 0.2s,\n    opacity 0.2s ease-in,\n    transform 0.2s ease-in;\n}\n\n.cesium-baseLayerPicker-dropDown-visible {\n  transform: translate(0, 0);\n  visibility: visible;\n  opacity: 1;\n  transition:\n    opacity 0.2s ease-out,\n    transform 0.2s ease-out;\n}\n\n.cesium-baseLayerPicker-sectionTitle {\n  display: block;\n  font-family: sans-serif;\n  font-size: 16pt;\n  text-align: left;\n  color: #edffff;\n  margin-bottom: 4px;\n}\n\n.cesium-baseLayerPicker-choices {\n  margin-bottom: 5px;\n}\n\n.cesium-baseLayerPicker-categoryTitle {\n  color: #edffff;\n  font-size: 11pt;\n}\n\n.cesium-baseLayerPicker-choices {\n  display: block;\n  border: 1px solid #888;\n  border-radius: 5px;\n  padding: 5px 0;\n}\n\n.cesium-baseLayerPicker-item {\n  display: inline-block;\n  vertical-align: top;\n  margin: 2px 5px;\n  width: 64px;\n  text-align: center;\n  cursor: pointer;\n}\n\n.cesium-baseLayerPicker-itemLabel {\n  display: block;\n  font-family: sans-serif;\n  font-size: 8pt;\n  text-align: center;\n  vertical-align: middle;\n  color: #edffff;\n  cursor: pointer;\n  word-wrap: break-word;\n}\n\n.cesium-baseLayerPicker-item:hover .cesium-baseLayerPicker-itemLabel,\n.cesium-baseLayerPicker-item:focus .cesium-baseLayerPicker-itemLabel {\n  text-decoration: underline;\n}\n\n.cesium-baseLayerPicker-itemIcon {\n  display: inline-block;\n  position: relative;\n  width: inherit;\n  height: auto;\n  background-size: 100% 100%;\n  border: solid 1px #444;\n  border-radius: 9px;\n  color: #edffff;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.cesium-baseLayerPicker-item:hover .cesium-baseLayerPicker-itemIcon {\n  border-color: #fff;\n  box-shadow:\n    0 0 8px #fff,\n    0 0 8px #fff;\n}\n\n.cesium-baseLayerPicker-selectedItem .cesium-baseLayerPicker-itemLabel {\n  color: rgb(189, 236, 248);\n}\n\n.cesium-baseLayerPicker-selectedItem .cesium-baseLayerPicker-itemIcon {\n  border: double 4px rgb(189, 236, 248);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
